var cookiesLib = require('./cookies')

$(document).ready(function () {
	if (window.exchangeCurrencies) {
		handleMenuAnimation()
		handleCookieCurrency()
		handleSwitchCurrency()
	} else {
		console.error('Missing "exchangeCurrencies" values')
	}

	// Fallback to prevent values to keep bluried
	setTimeout(function () {
		$('.currency-value').each(function () {
			var currencyValueItem = $(this)
			// Flag as loaded
			if (!currencyValueItem.hasClass('currency-loaded')) {
				currencyValueItem.addClass('currency-loaded')
			}
		})
	}, 1000)
})

// For reuse
window.switchExchangeRateCurrency = switchExchangeRateCurrency
window.loadExchangeRateFromSession = loadExchangeRateFromSession

function handleCookieCurrency () {
	// Adjusting URL by removing the temporary currency parameter
	let url = new URL(window.location.href)
	const params = new URLSearchParams(url.search)
	if (params.has('currency')) {
		url = url.origin + url.pathname
		window.history.replaceState(url, document.title, url)
	}

	var currentCurrency = cookiesLib.getCookie('currentCurrency')
	var geoLocationCurrencyCode = ''
	if (!currentCurrency) {
		geoLocationCurrencyCode = $('#ipGeolocation').data('currencyCode')
		sessionStorage.removeItem('currentCurrency')
	}

	var fromToKey = getFromToKey(currentCurrency || geoLocationCurrencyCode)
	var from = window.exchangeCurrencies.siteCurrency || 'EUR'
	var to
	if (fromToKey) {
		to = currentCurrency || geoLocationCurrencyCode
	} else {
		to = from
		fromToKey = getFromToKey(to)
	}

	var extraCurrencies = window.exchangeCurrencies.extraCurrencies || {}
	var rate = (extraCurrencies[fromToKey] && extraCurrencies[fromToKey].rate) || 1.0

	// If using GeoLocation, save it to cookie
	if (!currentCurrency && geoLocationCurrencyCode) {
		saveCookieCurrency(from, to, rate)
	}

	// Store on session storage for faster usage
	saveExchangeRateToSession(from, to, rate)

	switchExchangeRateCurrency(document, from, to, rate)

	// console.log(`Loaded cookie "currentCurrency": {"from":"${from}',"to":"${to}',"rate":${rate}}`)
}

function handleSwitchCurrency () {
	var exchangeRate = loadExchangeRateFromSession()
	if (exchangeRate && !isNaN(exchangeRate.rate)) {
		var fromToKey = getFromToKey(exchangeRate.to) || getFromToKey(exchangeRate.from)

		// Change active item on menu
		$('.currency-switch > span, .currency-language__currency > span, .currency-switch .currency-language__list-item-mobile  > span').removeClass('active')
		$(`.currency-switch-target-${exchangeRate.to}`).addClass('active')

		// Change item on new basket
		$('.sidepanel__select-currency').val(exchangeRate.to) // Select the option on basket dropdown, if any
		$('.sidepanel__select-currency-mobile').val(exchangeRate.to) // Select the option on basket dropdown, if any
	}

	function selectLanguage (event) {
		var selectedOption = $(this).find('option:selected')
		languageSwitch.bind(selectedOption)(event)
	}

	function languageSwitch (event) {
		event.preventDefault()
		// Remove active item on menu
		$('.currency-switch > span, .currency-language__currency > span, .currency-switch .currency-language__list-item-mobile > span').removeClass('active')

		var self = $(this)
		var from = self.data('from')
		var to = self.data('to')
		var rate = parseFloat(self.data('rate'))

		var fromToKey = getFromToKey(to) || getFromToKey(from)

		// Currencies cookie - For back-end
		saveCookieCurrency(from, to, rate)

		// Store on session storage for faster usage
		saveExchangeRateToSession(from, to, rate)

		switchExchangeRateCurrency(document, from, to, rate)

		if (window.langChanged) return false // Interrupt all other actions

		// Enable active item on menu
		$(`.currency-switch-item-${fromToKey}`).addClass('active')
		$('.sidepanel__select-currency').val(to) // Select the option on basket dropdown, if any
		$('.sidepanel__select-currency-mobile').val(to) // Select the option on basket dropdown, if any

		// Hide panel after selection - Not required for desktop and mobile menus, but required for basket sidepanel
		const topMenuLanguage = document.querySelector('.top-menu__wrapper .currency-language__wrapper')
		const panel = document.querySelector('.top-menu__wrapper .currency-language__panel')
		const chevron = topMenuLanguage && topMenuLanguage.querySelector('.chevron-down svg, .chevron-down img')
		const stateSetList = panel && panel.querySelectorAll('.state-set, .state-set-active')

		const toggleButtonMobile = document.querySelector('.header__wrapper .currency-language__wrapper-mobile')
		const panelMobile = document.querySelector('.header__wrapper .currency-language__panel-mobile')
		const chevronMobile = toggleButtonMobile.querySelector('.chevron-down-mobile svg, .chevron-down-mobile img')
		const stateSetListMobile = panelMobile && panelMobile.querySelectorAll('.state-set, .state-set-active')

		panel && panel.classList && panel.classList.remove('visible')
		chevron && chevron.classList && chevron.classList.remove('rotated')
		panelMobile && panelMobile.classList && panelMobile.classList.remove('visible')
		chevronMobile && chevronMobile.classList && chevronMobile.classList.remove('rotated')

		stateSetList && stateSetList.forEach(el => el.classList.remove('state-set', 'state-set-active'))
		stateSetListMobile && stateSetListMobile.forEach(el => el.classList.remove('state-set', 'state-set-active'))

		return false
	}

	$('.currency-switch-button').change(languageSwitch) // Custom CHANGE handler for non-input element - DO NOT CHANGE THIS
	$('.sidepanel').on('change', 'select.sidepanel__select-currency, select.sidepanel__select-currency-mobile', selectLanguage)
}

function getMenuState (menuButton, stateName) {
	if (!menuButton) return // console.log('Missing menuButton')

	const stateSet = menuButton.dataset.stateSet

	if (stateSet) {
		return window.stateStorage && window.stateStorage[stateSet] && window.stateStorage[stateSet][stateName]
	}
}

/**
 * Discard and open menu
 * @param {HTMLElement} menuButton
 */
function initMenuState (menuButton) {
	if (!menuButton) return // console.log('Missing menuButton')

	const stateSet = menuButton.dataset.stateSet

	if (stateSet) {
		window.stateStorage = window.stateStorage || {}
		window.stateStorage[stateSet] = {}
		menuButton.classList.add('menu-opened')
	}
}

function setMenuState (menuButton, stateName, stateValue) {
	if (!menuButton) return // console.log('Missing menuButton')

	const stateSet = menuButton.dataset.stateSet

	if (stateSet) {
		window.stateStorage = window.stateStorage || {}
		window.stateStorage[stateSet] = window.stateStorage[stateSet] || {}
		window.stateStorage[stateSet][stateName] = stateValue
	}
}

/**
 * Use the saved state
 * @param {HTMLElement} menuButton
 */
function applyMenuState (menuButton) {
	window.langChanged = false
	if (!menuButton) return // console.log('Missing menuButton')
	menuButton.classList.remove('menu-opened')

	const stateSet = menuButton.dataset.stateSet

	if (stateSet) {
		// Load settings
		window.stateStorage = window.stateStorage || {}
		window.stateStorage[stateSet] = window.stateStorage[stateSet] || {}
		const currencyBtnId = window.stateStorage[stateSet].currencyBtnId
		const languageBtnId = window.stateStorage[stateSet].languageBtnId
		window.stateStorage[stateSet] = {}

		// Apply
		const currencyBtn = currencyBtnId && document.getElementById(currencyBtnId)
		const languageBtn = languageBtnId && document.getElementById(languageBtnId)

		const currentSiteLang = document.documentElement.dataset.siteLabel
		const selectedLang = languageBtn && languageBtn.dataset.lang

		if (currencyBtn) { currencyBtn.dispatchEvent(new Event('change')) }
		if (languageBtn && currentSiteLang !== selectedLang) { window.langChanged = true; languageBtn.dispatchEvent(new Event('change')) }

		// Clear after applying
		window.stateStorage[stateSet] = {}
	}

	return window.langChanged
}

/**
 * Discard and close menu
 * @param {HTMLElement} menuButton
 */
function discardMenuState (menuButton) {
	if (!menuButton) return // console.log('Missing menuButton')
	menuButton.classList.remove('menu-opened')

	const stateSet = menuButton.dataset.stateSet

	if (stateSet) {
		window.stateStorage = window.stateStorage || {}
		window.stateStorage[stateSet] = {}
	}
}

function validateCurrencyForLang (lang, currency) {
	const selectedSite = window.exchangeCurrencies.siteList.filter(site => site.label === lang)[0]
	const baseCurrency = selectedSite && selectedSite.baseCurrency
	const availableCurrencies = (selectedSite && selectedSite.availableCurrencies) || []
	const currencyIsAvailable = currency && availableCurrencies.indexOf(currency) !== -1
	return { isAvailable: currencyIsAvailable, baseCurrency }
}

function handleMenuAnimation () {
	const topMenuLanguage = document.querySelector('.top-menu__wrapper .currency-language__wrapper')
	const panel = document.querySelector('.top-menu__wrapper .currency-language__panel')
	const menuButton = topMenuLanguage && topMenuLanguage.querySelector('.currency-language__btn')
	const chevron = topMenuLanguage && topMenuLanguage.querySelector('.chevron-down svg, .chevron-down img')
	const menuApply = panel && panel.querySelector('.pref-apply-button')
	const getStateSetList = ((parent) => parent && parent.querySelectorAll('.state-set, .state-set-active'))
	const replaceCurrencyEnabled = (langToEnable => {
		const currencyEnableItems = panel.querySelectorAll('[class^="currency-enable-site-"],[class*=" currency-enable-site-"]')
		const classesToRemove = getClassesStartingWith(currencyEnableItems, 'currency-enable-site-')
		currencyEnableItems.forEach(el => {
			el.classList.remove(...classesToRemove)
			el.classList.add(langToEnable)
		}) // Replace existing site-enable classes by the new selected one
	})
	const triggerClickOnEquivalentCurrency = (lang => {
		const currencyBtnId = getMenuState(menuButton, 'currencyBtnId')
		let currencyTo = (currencyBtnId && currencyBtnId.split('_')[1]) || cookiesLib.getCookie('currentCurrency')
		const check = validateCurrencyForLang(lang, currencyTo)

		if (!check.baseCurrency) return // Validating required fields

		if (!check.isAvailable) {
			currencyTo = check.baseCurrency
		}
		const idPrefix = 'currency'
		const newId = `${idPrefix}-${lang}-${check.baseCurrency}_${currencyTo}`

		// Trigger click
		const currencyBtn = document.getElementById(newId)

		if (currencyBtn) { currencyBtn.dispatchEvent(new CustomEvent('click', { detail: 'triggered' })) }
	})
	const hideCurrencyPanel = (btn => {
		if (btn.classList.contains('menu-opened')) {
			// Trigger click
			btn.dispatchEvent(new Event('click'))
		}
	})

	// Handle click outside the menu or pressing ESC
	window.currencyLanguageGroup = document.querySelector('.currency-language-group')
	document.addEventListener('click', event => {
		if (event.target instanceof Element) {
			/* @type {HTMLElement} */
			const clickedElement = event.target
			if (window.currencyLanguageGroup.contains(clickedElement)) {
				// console.log('Currency-Language group contains clicked element')
			} else {
				// console.log('Currency-Language group does not contain clicked element')
				hideCurrencyPanel(menuButton)
			}
		} else {
			// console.log('Not an Element')
		}
	})
	document.body.addEventListener('keydown', event => {
		if (event.key === 'Escape' && window.currencyLanguageGroup.contains(document.activeElement)) { // escape key maps to keycode `27`
			hideCurrencyPanel(menuButton)
		}
	})

	menuButton && menuButton.addEventListener('click', event => {
		event.preventDefault()

		if (menuButton.classList.contains('menu-opened')) {
			discardMenuState(menuButton)
			panel && panel.classList.remove('visible')
			chevron && chevron.classList.remove('rotated')
			const stateSetList = getStateSetList(panel)
			stateSetList && stateSetList.forEach(el => el.classList.remove('state-set', 'state-set-active'))
			replaceCurrencyEnabled(`currency-enable-site-${document.documentElement.dataset.siteLabel}`) // Reset site-related currencies
		} else {
			initMenuState(menuButton)
			panel && panel.classList.add('visible')
			chevron && chevron.classList.add('rotated')
		}

		return false
	})

	menuApply && menuApply.addEventListener('click', event => {
		event.preventDefault()

		if (menuButton.classList.contains('menu-opened')) {
			applyMenuState(menuButton)
			if (window.langChanged) return false // Interrupt all other actions
			panel && panel.classList.remove('visible')
			chevron && chevron.classList.remove('rotated')
			const stateSetList = getStateSetList(panel)
			stateSetList && stateSetList.forEach(el => el.classList.remove('state-set', 'state-set-active'))
			replaceCurrencyEnabled(`currency-enable-site-${document.documentElement.dataset.siteLabel}`) // Reset site-related currencies
		}

		return false
	})

	menuButton && document.querySelectorAll('.lang-link-desktop').forEach(langLink => {
		langLink.addEventListener('click', event => {
			event.preventDefault()

			// Change UI to reflect the temporarily selected currency
			// const panelMatched = parentMatch('.currency-language__panel', langLink, 5)
			const wrapperMatched = parentMatch('.currency-language__panel .lang', langLink, 4)
			const buttonMatched = parentMatch('[class^="lang-item-"],[class*=" lang-item-"]', langLink, 3)
			if (wrapperMatched && buttonMatched /*&& panelMatched*/) {
				wrapperMatched.querySelectorAll('.state-set, .state-set-active')
					.forEach(el => el.classList.remove('state-set', 'state-set-active')) // Remove all flags
				wrapperMatched.classList.add('state-set') // Add a flag class to the wrapper parent tag
				buttonMatched.classList.add('state-set-active') // Add another flag class to the clicked element
				replaceCurrencyEnabled(buttonMatched.dataset.enable) // Reset site-related currencies
				triggerClickOnEquivalentCurrency(langLink.dataset.lang) // Force currency change
			}

			setMenuState(menuButton, 'languageBtnId', langLink.id)
			return false
		})

		langLink.addEventListener('change', event => {
			event.preventDefault()

			// console.log('langLink change to ' + event.target.href)
			/** @type {HTMLAnchorElement} */
			let self = event.target
			let currentCurrency = cookiesLib.getCookie('currentCurrency')
			const check = validateCurrencyForLang(self.dataset.lang, currentCurrency)
			currentCurrency = check.isAvailable ? currentCurrency : check.baseCurrency
			window.location = self.href + (currentCurrency ? '?currency=' + currentCurrency : '')

			return false
		})
	})

	menuButton && document.querySelectorAll('.currency-switch-desktop').forEach(currencySwitch => {
		currencySwitch.addEventListener('click', event => {
			event.preventDefault()

			// Change UI to reflect the temporarily selected currency
			const wrapperMatched = parentMatch('.currency-language__panel .currency-switch', currencySwitch, 5)
			const buttonMatched = parentMatch('[class^="currency-switch-item-"],[class*=" currency-switch-item-"]', currencySwitch, 3)
			if (wrapperMatched && buttonMatched) {
				wrapperMatched.querySelectorAll('.state-set, .state-set-active')
					.forEach(el => el.classList.remove('state-set', 'state-set-active')) // Remove all flags
				wrapperMatched.classList.add('state-set') // Add a flag class to the wrapper parent tag
				buttonMatched.classList.add('state-set-active') // Add another flag class to the clicked element
			}

			const wasTriggeredByCode = event.detail === 'triggered'
			if (!wasTriggeredByCode) {
				setMenuState(menuButton, 'currencyBtnId', currencySwitch.id)
			}
			return false
		})
	})

	const menuButtonMobile = document.querySelector('.header__wrapper .currency-language__wrapper-mobile')
	const panelMobile = document.querySelector('.header__wrapper .currency-language__panel-mobile')
	const chevronMobile = menuButtonMobile.querySelector('.chevron-down-mobile svg, .chevron-down-mobile img')
	const menuApplyMobile = panelMobile && panelMobile.querySelector('.pref-apply-button')
	const getStateSetListMobile = ((parent) => parent && parent.querySelectorAll('.state-set, .state-set-active'))
	const replaceCurrencyEnabledMobile = (langToEnable => {
		const currencyEnableItems = panelMobile.querySelectorAll('[class^="currency-enable-site-"],[class*=" currency-enable-site-"]')
		const classesToRemove = getClassesStartingWith(currencyEnableItems, 'currency-enable-site-')
		currencyEnableItems.forEach(el => {
			el.classList.remove(...classesToRemove)
			el.classList.add(langToEnable)
		}) // Replace existing site-enable classes by the new selected one
	})
	const triggerClickOnEquivalentCurrencyMobile = (lang => {
		const currencyBtnId = getMenuState(menuButtonMobile, 'currencyBtnId')
		let currencyTo = (currencyBtnId && currencyBtnId.split('_')[1]) || cookiesLib.getCookie('currentCurrency')
		const check = validateCurrencyForLang(lang, currencyTo)

		if (!check.baseCurrency) return // Validating required fields

		if (!check.isAvailable) {
			currencyTo = check.baseCurrency
		}

		const idPrefix = 'currency-mobile'
		const newId = `${idPrefix}-${lang}-${check.baseCurrency}_${currencyTo}`

		// Trigger click
		const currencyBtn = document.getElementById(newId)
		if (currencyBtn) { currencyBtn.dispatchEvent(new CustomEvent('click', { detail: 'triggered' })) }
	})

	if (menuButtonMobile) {
		const menuClickableAreaMobile = menuButtonMobile.querySelector('.currency-language__select') // Clickable area inside mobile menu should not cross the actual items
		menuClickableAreaMobile && menuClickableAreaMobile.addEventListener('click', event => {
			event.preventDefault()

			if (menuButtonMobile.classList.contains('menu-opened')) {
				discardMenuState(menuButtonMobile)
				panelMobile && panelMobile.classList.remove('visible')
				chevronMobile && chevronMobile.classList.remove('rotated')
				const stateSetListMobile = getStateSetListMobile(panelMobile)
				stateSetListMobile && stateSetListMobile.forEach(el => el.classList.remove('state-set', 'state-set-active'))
				replaceCurrencyEnabledMobile(`currency-enable-site-${document.documentElement.dataset.siteLabel}`) // Reset site-related currencies
			} else {
				initMenuState(menuButtonMobile)
				panelMobile && panelMobile.classList.add('visible')
				chevronMobile && chevronMobile.classList.add('rotated')
			}

			return false
		})
	}

	// Add event listener for menu-button-toggle in mobile and prevend the currency panel from being opened when user opens menu again.
	const menuToggleButton = document.querySelector('.menu-button-toggle');
	menuToggleButton && menuToggleButton.addEventListener('click', event => {
		event.preventDefault()

		if (menuButtonMobile && menuButtonMobile.classList.contains('menu-opened')) {
			discardMenuState(menuButtonMobile)
			panelMobile && panelMobile.classList.remove('visible')
			chevronMobile && chevronMobile.classList.remove('rotated')
			const stateSetListMobile = getStateSetListMobile(panelMobile)
			stateSetListMobile && stateSetListMobile.forEach(el => el.classList.remove('state-set', 'state-set-active'))
			replaceCurrencyEnabledMobile(`currency-enable-site-${document.documentElement.dataset.siteLabel}`) // Reset site-related currencies
		}

		return false
	})

	menuApplyMobile && menuApplyMobile.addEventListener('click', event => {
		event.preventDefault()

		if (menuButtonMobile && menuButtonMobile.classList.contains('menu-opened')) {
			applyMenuState(menuButtonMobile)
			if (window.langChanged) return false // Interrupt all other actions
			panelMobile && panelMobile.classList.remove('visible')
			chevronMobile && chevronMobile.classList.remove('rotated')
			const stateSetListMobile = getStateSetListMobile(panelMobile)
			stateSetListMobile && stateSetListMobile.forEach(el => el.classList.remove('state-set', 'state-set-active'))
			if (menuToggleButton) {
				const asNavMegaMenuMobile = parentMatch('.as-nav', menuToggleButton, 5)
				asNavMegaMenuMobile && asNavMegaMenuMobile.classList.remove('mega-menu')
			}
			replaceCurrencyEnabledMobile(`currency-enable-site-${document.documentElement.dataset.siteLabel}`) // Reset site-related currencies
		}

		return false
	})

	menuButtonMobile && document.querySelectorAll('.lang-link-mobile').forEach(langLinkMobile => {
		langLinkMobile.addEventListener('click', event => {
			event.preventDefault()

			// Change UI to reflect the temporarily selected currency
			// const panelMatchedMobile = parentMatch('.currency-language__panel-mobile', langLinkMobile, 5)
			const wrapperMatchedMobile = parentMatch('.currency-language__list-mobile.lang', langLinkMobile, 4)
			const buttonMatchedMobile = parentMatch('[class^="lang-item-"],[class*=" lang-item-"]', langLinkMobile, 3)
			if (wrapperMatchedMobile && buttonMatchedMobile /*&& panelMatchedMobile*/) {
				wrapperMatchedMobile.querySelectorAll('.state-set, .state-set-active')
					.forEach(el => el.classList.remove('state-set', 'state-set-active')) // Remove all flags
				wrapperMatchedMobile.classList.add('state-set') // Add a flag class to the wrapper parent tag
				buttonMatchedMobile.classList.add('state-set-active') // Add another flag class to the clicked element
				replaceCurrencyEnabledMobile(buttonMatchedMobile.dataset.enable) // Reset site-related currencies
				triggerClickOnEquivalentCurrencyMobile(langLinkMobile.dataset.lang) // Force currency change
			}

			setMenuState(menuButtonMobile, 'languageBtnId', langLinkMobile.id)
			return false
		})

		langLinkMobile.addEventListener('change', event => {
			event.preventDefault()

			// console.log('langLinkMobile change to ' + event.target.href)
			/** @type {HTMLAnchorElement} */
			let self = event.target
			let currentCurrency = cookiesLib.getCookie('currentCurrency')
			const check = validateCurrencyForLang(self.dataset.lang, currentCurrency)
			currentCurrency = check.isAvailable ? currentCurrency : check.baseCurrency
			window.location = self.href + (currentCurrency ? '?currency=' + currentCurrency : '')

			return false
		})
	})

	menuButtonMobile && document.querySelectorAll('.currency-switch-mobile').forEach(currencySwitchMobile => {
		currencySwitchMobile.addEventListener('click', event => {
			event.preventDefault()

			// Change UI to reflect the temporarily selected currency - Mobile
			const wrapperMatchedMobile = parentMatch('.currency-language__list-mobile.currency-switch', currencySwitchMobile, 5)
			const buttonMatchedMobile = parentMatch('[class^="currency-switch-item-"],[class*=" currency-switch-item-"]', currencySwitchMobile, 3)
			if (wrapperMatchedMobile) {
				wrapperMatchedMobile.querySelectorAll('.state-set, .state-set-active')
					.forEach(el => el.classList.remove('state-set', 'state-set-active')) // Remove all flags
				wrapperMatchedMobile.classList.add('state-set') // Add a flag class to the wrapper parent tag
				buttonMatchedMobile.classList.add('state-set-active') // Add another flag class to the clicked element
			}

			const wasTriggeredByCode = event.detail === 'triggered'
			if (!wasTriggeredByCode) {
				setMenuState(menuButtonMobile, 'currencyBtnId', currencySwitchMobile.id)
			}
			return false
		})
	})
}

/**
 * @param {string} targetCurrencyCode
 * @returns {string} FROM_TO key, if it's valid (available pair)
 */
function getFromToKey (targetCurrencyCode) {
	var from = window.exchangeCurrencies.siteCurrency || 'EUR'
	var to = targetCurrencyCode
	var fromToKey = `${from}_${to}`
	var extraCurrencies = window.exchangeCurrencies.extraCurrencies || {}
	if (extraCurrencies[fromToKey] || from === to) return fromToKey
	return undefined
}

/**
 * @param {string} from
 * @param {string} to
 * @param {number|string} rate
 */
function saveCookieCurrency (from, to, rate) {
	document.cookie = `currentCurrency=${to}; path=/; samesite=lax` // No expiration, so it lasts as longs there are tabs opened (running the same session)

	// console.log(`Saved cookie "currentCurrency": {"from":"${from}',"to":"${to}',"rate":${rate}}`)
}

/**
 * @returns {{from:string,to:string,rate:number}}
 */
function loadExchangeRateFromSession () {
	var from = sessionStorage.getItem('exchangeCurrencies-from')
	var to = sessionStorage.getItem('exchangeCurrencies-to')
	var rate = sessionStorage.getItem('exchangeCurrencies-rate')
	return { from, to, rate: rate && parseFloat(rate) }
}

/**
 * @param {string} from
 * @param {string} to
 * @param {number} rate
 */
function saveExchangeRateToSession (from, to, rate) {
	sessionStorage.setItem('exchangeCurrencies-from', from)
	sessionStorage.setItem('exchangeCurrencies-to', to)
	sessionStorage.setItem('exchangeCurrencies-rate', rate)
	return { from, to, rate }
}

/**
 * @param {HTMLElement} baseElement
 * @param {string} from
 * @param {string} to
 * @param {number} rate
 */
function switchExchangeRateCurrency (baseElement, from, to, rate) {
	if (window.exchangeCurrencies && window.exchangeCurrencies.siteCurrency === from) {
		if (from !== to) {
			findAndConvertCurrencies(baseElement, from, to, rate)
		} else {
			findAndRevertCurrencies(baseElement)
		}
	}
}

/**
 * @param {HTMLElement} baseElement
 * @param {string} from
 * @param {string} to
 */
function findAndRevertCurrencies (baseElement) {
	if (!baseElement) return
	var root = $(baseElement)
	root.find('.currency-value').each(function () {
		var currencyValueItem = $(this)
		var currencyChildTag = currencyValueItem.find('.currency-value-currency')[0]
		var valueChildTag = currencyValueItem.find('.currency-value-value')[0]
		var mixedChildTag = currencyValueItem.find('.currency-value-mixed')[0]
		var originalPriceText = null

		if (currencyChildTag && (originalPriceText = currencyChildTag.dataset.originalPriceText)) {
			$(currencyChildTag).text(originalPriceText)
		}
		if (valueChildTag && (originalPriceText = valueChildTag.dataset.originalPriceText)) {
			$(valueChildTag).text(originalPriceText)
		}
		if (mixedChildTag && (originalPriceText = mixedChildTag.dataset.originalPriceText)) {
			$(mixedChildTag).text(originalPriceText)
		}

		originalPriceText = currencyValueItem.data('originalPriceText')
		if (!originalPriceText) {
			return // Skip invalid
		} else if (!currencyChildTag && !valueChildTag && !mixedChildTag) {
			currencyValueItem.text(originalPriceText)
		}

		// Flag as loaded
		if (!currencyValueItem.hasClass('currency-loaded')) {
			currencyValueItem.addClass('currency-loaded')
		}

		// Flag decimals
		if (valueChildTag) {
			valueChildTag = $(valueChildTag)
			const hasClassDecimals = valueChildTag.hasClass('currency-value-with-decimals')
			const containsDecimalsPrice = containsDecimals(originalPriceText)
			if (!hasClassDecimals && containsDecimalsPrice) {
				valueChildTag.addClass('currency-value-with-decimals')
			} else if (hasClassDecimals && !containsDecimalsPrice) {
				valueChildTag.removeClass('currency-value-with-decimals')
			}
		}
	})
	root.find('.currency-value-orig').removeClass('currency-loaded')
}

/**
 * @param {HTMLElement} baseElement
 * @param {string} from
 * @param {string} to
 */
function findAndConvertCurrencies (baseElement, from, to, rate) {
	if (!baseElement) return
	// The character codes \u202F \u00A0 \u0020 are for non-breaking spaces and breaking spaces
	var moneyRegex = /([A-Z]{3,4})\s+(-?[\u202F\u00A0\u00200-9]+)/g
	var root = $(baseElement)
	var isBookingPage = $('#bookingId').length > 0
	root.find('.currency-value').each(function () {
		var currencyValueItem = $(this)
		var currencyChildTag = currencyValueItem.find('.currency-value-currency')[0]
		var valueChildTag = currencyValueItem.find('.currency-value-value')[0]
		var mixedChildTag = currencyValueItem.find('.currency-value-mixed')[0]

		var originalPriceText = currencyValueItem.data('originalPriceText')
		if (!originalPriceText) return

		var showBasePrice = currencyValueItem.data('showBasePrice')
		showBasePrice = String(showBasePrice) === 'true'

		var matchesIter = originalPriceText.matchAll(moneyRegex)
		var matches = [...matchesIter]
		if (Array.isArray(matches[0])) matches = matches[0]
		var price
		var currencyPrice
		matches.forEach(function (match) {
			match = parseInt(match && String(match).replace(/[\u202F\u00A0\u0020]/g, ''))
			if (!isNaN(match)) {
				price = match
			}
		})
		if (!isNaN(price)) {
			price = calculateExchange(price, rate, window.exchangeCurrencies.exchangeMarkup)
			if (isBookingPage && window.exchangeCurrencies.siteCurrency !== to) {
				price = new Intl.NumberFormat('no', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(price)
			} else {
				price = new Intl.NumberFormat('no', { maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(price)
			}
			price = price.replace(',', '.') // Fix decimal separator
				.replace('\u2212', '-') // Fix the minus sign
				.replace(/[\u202F\u00A0\u0020]+/g, '\u00A0') // Fix the space symbol
			currencyPrice = `${to} ${price}`
			if (!currencyChildTag && !valueChildTag && !mixedChildTag) {
				currencyValueItem.text(originalPriceText.replace(moneyRegex, (showBasePrice ? `$1 $2 (${currencyPrice})` : currencyPrice)))
			} else {
				currencyChildTag && $(currencyChildTag).text(to)
				valueChildTag && $(valueChildTag).text(price)
				mixedChildTag && $(mixedChildTag).text(originalPriceText.replace(moneyRegex, (showBasePrice ? `$1 $2 (${currencyPrice})` : currencyPrice)))
			}

			// Flag as loaded
			if (!currencyValueItem.hasClass('currency-loaded')) {
				currencyValueItem.addClass('currency-loaded')
			}

			// Flag decimals
			if (valueChildTag) {
				valueChildTag = $(valueChildTag)
				const hasClassDecimals = valueChildTag.hasClass('currency-value-with-decimals')
				const containsDecimalsPrice = containsDecimals(price)
				if (!hasClassDecimals && containsDecimalsPrice) {
					valueChildTag.addClass('currency-value-with-decimals')
				} else if (hasClassDecimals && !containsDecimalsPrice) {
					valueChildTag.removeClass('currency-value-with-decimals')
				}
			}
		}
	})
	root.find('.currency-value-orig').each(function () {
		var currencyOrigItem = $(this)
		// Flag as loaded
		if (!currencyOrigItem.hasClass('currency-loaded')) {
			currencyOrigItem.addClass('currency-loaded')
		}
	})
}

/**
 * Detects if a money-formatted string contains decimals
 * @param {string} moneyString - The money-formatted string to check
 * @returns {boolean} - True if the string contains decimals, false otherwise
 */
function containsDecimals (moneyString) {
	if (!moneyString) return
	// Regular expression to match decimal numbers
	const decimalRegex = /\d+\.\d+/;
	return decimalRegex.test(moneyString);
}

/**
 * Detects if a money-formatted string contains decimals
 * @param {string} moneyString - The money-formatted string to check
 * @returns {boolean} - True if the string contains decimals, false otherwise
 */
function containsDecimals (moneyString) {
	if (!moneyString) return
	// Regular expression to match decimal numbers
	const decimalRegex = /\d+\.\d+/;
	return decimalRegex.test(moneyString);
}

/**
 * @param {number} moneyValue
 * @param {number} exchangeRate Useful if > 0 and !== 1
 * @param {number} exchangeMarkup
 * @param {number} [offerDiscount]
 * @returns {number|undefined}
 */
function calculateExchange (moneyValue, exchangeRate, exchangeMarkup, offerDiscount) {
	var percentDiscount = !offerDiscount ? 1 : (100 - offerDiscount) / 100
	if (exchangeRate <= 0 || exchangeRate === 1) return moneyValue * percentDiscount // Apply only the discount

	var percentMarkup = !exchangeMarkup ? 1 : (100 + exchangeMarkup) / 100
	var rateWithMarkup = roundDecimals(exchangeRate * percentMarkup, 2)

	// For smaller rates, we cannot round to 2 decimals
	if (rateWithMarkup === 0) { // The difference between rates is too big
		rateWithMarkup = roundDecimals(exchangeRate * percentMarkup, 3)

		// For even smaller rates, we cannot round 3 decimals
		if (rateWithMarkup === 0) { // The difference between rates is too big
			rateWithMarkup = roundDecimals(exchangeRate * percentMarkup, 4)
		}
	}

	return moneyValue * rateWithMarkup * percentDiscount
}

/**
 * Rounds a number to a specific number of decimal places
 * @param {number} value - The number to round
 * @param {number} decimals - The number of decimal places
 * @returns {number} - The rounded number
 */
function roundDecimals (value, decimals) {
	if (isNaN(value) || isNaN(decimals)) return value
	const factor = Math.pow(10, decimals)
	return Math.round((value + 0.0000001) * factor) / factor
}

/**
 * @param {string} selector CSS selector to match
 * @param {HTMLElement} element Base element to start searching
 * @param {number} limit Number of iterations when going up on the DOM tree
 * @returns {HTMLElement|null} `HTMLElement` or `null`
 */
function parentMatch (selector, element, limit) {
	if (!element || !element.matches || limit < 0) return null
	if (element.matches(selector)) return element
	return parentMatch(selector, element.parentElement, limit - 1)
}

/**
 *
 * @param {NodeListOf<HTMLElement>} nodeList
 * @param {string} prefix
 * @returns {string[]} Filtered list of class names
 */
function getClassesStartingWith (nodeList, prefix) {
	const classes = {};
	nodeList.forEach(element => {
		element.classList.forEach(className => {
			if (className.startsWith(prefix)) {
				classes[className] = true
			}
		});
	});
	return Object.keys(classes)
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/exchangeCurrencies.js